import { render, staticRenderFns } from "./FormaPagoComponent.vue?vue&type=template&id=715b0457&"
import script from "./FormaPagoComponent.vue?vue&type=script&lang=js&"
export * from "./FormaPagoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports